// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DatePicker_wrapper__3HlTq","box":"DatePicker_box__21MKc","box2":"DatePicker_box2__2Ixj_","box3":"DatePicker_box3__mIQ05"};